import { formatPrice } from '@/utils/circuits/prices/formatPrice';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { Translator } from '../translator.type';

export type Bill = {
  id: string;
  fileKey: string;
  fileUrl: string;
  amount: number;
  createdAt: string;
};

export const BILL_COLUMN_DEF = (t: Translator): ColumnDef<Bill>[] => [
  {
    accessorKey: 'fileKey',
    header: t('pages.profile.billColumns.name'),
  },
  {
    accessorKey: 'amount',
    header: t('pages.profile.billColumns.amount'),
    cell: ({ row }) => {
      return <div>{formatPrice(row.original.amount)} €</div>;
    },
  },
  {
    accessorKey: 'createdAt',
    header: t('pages.profile.billColumns.createdAt'),
    cell: ({ row }) => {
      return (
        <div>{format(new Date(row.original.createdAt), 'dd/MM/yyyy')}</div>
      );
    },
  },
];
